import Cookie from 'js-cookie';
import { useEffect } from 'react';
import { useLocation } from 'react-router-7';
import { v4 } from 'uuid';

import { logger } from 'src/utils/datadog-log-wrapper';

import { redirectToAuth2Flow, getRedirectUri } from './googleMethods';
import { LargeButton } from '../LargeButton/LargeButton';

export const googleIdentityServicesErrorCodes = [
  'access_denied',
  'immediate_failed',
];

export type GoogleIdentityServicesError =
  (typeof googleIdentityServicesErrorCodes)[number];

export const googleIdentityServicesErrorCodeToTranslationKey = (
  errorCode: GoogleIdentityServicesError,
) => {
  if (errorCode === 'access_denied') {
    return 'errorGoogle.accessDenied';
  }
  if (errorCode === 'immediate_failed') {
    return 'errorGoogle.immediateFailed';
  }
  return 'errorGoogle.generic';
};

export type GoogleOauthSuccessResponse = {
  code: string;
  redirectUrl: string;
};

type GoogleIdentityServicesButtonProps = {
  isLoading?: boolean;
  isDisabled?: boolean;
  message: string;
  onSuccess: (resp: GoogleOauthSuccessResponse) => void;
};

export const logId = v4();

const GoogleIdentityServicesButton = ({
  isLoading = false,
  isDisabled = false,
  message,
  onSuccess,
}: GoogleIdentityServicesButtonProps) => {
  const { search } = useLocation();

  useEffect(() => {
    const queryParameters = new URLSearchParams(search);
    const code = queryParameters.get('code');

    if (code) {
      logger.info('Google OAuth2 - google flow callback successful', {
        team: 'travel-and-expenses',
        scope: 'auth::google',
        deviceId: Cookie.get('spendeskDeviceUUID'),
        logId,
      });
      onSuccess({
        code,
        redirectUrl: getRedirectUri(),
      });
    } else {
      logger.info('Google OAuth2 -  useEffect called without code', {
        team: 'travel-and-expenses',
        scope: 'auth::google',
        logId,
        deviceId: Cookie.get('spendeskDeviceUUID'),
      });
    }
  }, [search]);

  return (
    <LargeButton
      variant="secondaryNeutral"
      onClick={() => {
        logger.info('Google OAuth2 - click on the button', {
          team: 'travel-and-expenses',
          scope: 'auth::google',
          deviceId: Cookie.get('spendeskDeviceUUID'),
          logId,
        });
        redirectToAuth2Flow();
      }}
      text={message}
      isDisabled={isDisabled || isLoading}
      isLoading={isLoading}
      provider="google"
    />
  );
};

export default GoogleIdentityServicesButton;
